import React, {useState, useEffect, forwardRef} from 'react';

import * as S from '../ProfileInfo/ProfileInfo.styles';
import Modal, {useModal} from '../../../../../../../hotels-dweb/src/shared/components/Modal';
import AddGstModal from './AddGstModal/AddGstModal';
import {manageGstTable} from './data';
import {logOmniClick} from '@ibibo/analytics';
import EmptyInvoice from '../../../TransactionalReport/GstInvoiceReport/GstInvoice/EmptyInvoice/EmptyInvoice';
import noInvoicePng from '../../../../../stories/components/RefundRaiseRequest/assets/no-request.png';
import DeleteGstModal from './DeleteGstModal/DeleteGstModal';
import {transformData} from '../../../../../utils/formatJson';

const ManageGst = forwardRef(({userData}, ref) => {
  const {isModalOpen, openModal, closeModal} = useModal();
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [modalDimenstions, setModalDimenstions] = useState(false);

  useEffect(() => {
    setTableData(transformData(userData?.traveller_gst_info?.gstDetails || []));
  }, [userData]);

  const handleDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleModalData = data => {
    setModalData(data);
    logOmniClick('mysettings:gst', {
      prop54: `CTA –Edit_GST_Clicked `,
    });
  };

  const handleModalClose = () => {
    closeModal();
    setModalData({});
  };

  const handleAddCtaClick = () => {
    logOmniClick('mysettings:gst', {
      prop54: `CTA –Add_GST_Clicked `,
    });
    openModal();
  };

  return (
    <S.ProfileMainWrap ref={ref} id="coachMarkRef">
      <S.ProfileInnerWrap>
        <S.ProfileHeadOuterWrap>
          <S.ProfileHeadInnerWrap>
            <S.HeadMainText>Manage GST</S.HeadMainText>
            <S.HeadSubText>
              Add details of your travel agency's or client’s GST to save them for reuse
            </S.HeadSubText>
          </S.ProfileHeadInnerWrap>
          <S.manageGstAddButton onClick={handleAddCtaClick}>+ ADD</S.manageGstAddButton>
        </S.ProfileHeadOuterWrap>

        <S.ManageGstMainWrap>
          {tableData.length ? (
            <S.ProfileTableSection cellpadding="0" cellspacing="0">
              <S.ProfileTableHead>
                <S.ProfileTableHeadingRow>
                  {manageGstTable?.tableHeading?.map(tableHeading => (
                    <S.ProfileTableth width={tableHeading?.headingWidth}>
                      {tableHeading?.headingTxt}
                    </S.ProfileTableth>
                  ))}
                </S.ProfileTableHeadingRow>
              </S.ProfileTableHead>
              {
                <S.ProfileTableBody>
                  <div>
                    {tableData?.map(tableRow => (
                      <S.ProfileTableRow>
                        <S.TableRowContent>
                          {tableRow?.tableRowData?.map(tableRowData => {
                            return (
                              <S.ProfileTableTd
                                width={tableRowData?.dataTxtWidth}
                                color={tableRowData?.rowDataColor}
                                weight={tableRowData?.rowDataWeight}
                              >
                                {!!tableRowData.rowDataTxt && tableRowData?.rowDataTxt}
                                {!!tableRowData.rowIconOne && (
                                  <span
                                    className={`${tableRowData.rowIconOne}`}
                                    onClick={e => {
                                      openModal(), handleModalData(tableRow?.rowEditData);
                                    }}
                                  ></span>
                                )}
                                {!!tableRowData.rowIconTwo && (
                                  <span
                                    className={`${tableRowData.rowIconTwo}`}
                                    onClick={() => {
                                      setDeleteModal(true),
                                        handleModalData(tableRow?.rowDeleteData);
                                    }}
                                  ></span>
                                )}
                                {!!tableRowData.dataTagTxt && (
                                  <>
                                    <br />
                                    <S.ProfileTdTag
                                      color={tableRowData?.dataTagColor}
                                      background={tableRowData?.dataTagBg}
                                    >
                                      {tableRowData?.dataTagTxt}
                                    </S.ProfileTdTag>
                                  </>
                                )}
                              </S.ProfileTableTd>
                            );
                          })}
                        </S.TableRowContent>
                        {!!tableRow.rowPersuasion && (
                          <S.ProfileRowPersuasion
                            background={tableRow?.rowPersuasion?.rowPersBackground}
                            color={tableRow?.rowPersuasion?.rowPersColor}
                            margin="0px 12px 24px 12px"
                          >
                            <span className={`${tableRow?.rowPersuasion?.rowPersIc}`}></span>
                            <span className="marginLeft8">
                              {tableRow?.rowPersuasion?.rowPersTxt}
                            </span>
                          </S.ProfileRowPersuasion>
                        )}
                      </S.ProfileTableRow>
                    ))}
                  </div>
                </S.ProfileTableBody>
              }
            </S.ProfileTableSection>
          ) : (
            <div
              onClick={e => {
                if (e?.target?.matches('.add-gst')) {
                  handleAddCtaClick();
                }
              }}
            >
              <EmptyInvoice
                icon={noInvoicePng}
                description={`
                No GST Details Added. <span><br/>Click 
                <span class="add-gst" style="color: #008cff; cursor: pointer;" >+ADD</span> 
                to begin adding GST details to our account</span>.
              `}
                showContainer={false}
              />
            </div>
          )}
        </S.ManageGstMainWrap>
      </S.ProfileInnerWrap>
      <Modal
        isOpen={isModalOpen}
        closeModal={handleModalClose}
        hideCloseButton={false}
        modalStyles={
          modalDimenstions
            ? {
                width: '450px',
                height: '200px',
              }
            : {
                width: '600px',
                height: '560px',
              }
        }
      >
        <AddGstModal setModalDimenstions={setModalDimenstions} initialFormValues={modalData} />
      </Modal>
      <Modal
        isOpen={isDeleteModal}
        closeModal={handleDeleteModal}
        hideCloseButton={false}
        modalStyles={{
          width: '490px',
          height: 'max-content',
        }}
      >
        <DeleteGstModal closeModal={handleDeleteModal} modalData={modalData} />
      </Modal>
    </S.ProfileMainWrap>
  );
});

export default ManageGst;
